import { GetterTree } from "vuex";
import { CustomerState } from "@/store/customer/type";
import { RootState } from "@/store/type";

export const getters: GetterTree<CustomerState, RootState> = {
  getProfile: (state: CustomerState) => {
    return state.me;
  },
  isAuthenticated: (state: CustomerState) => {
    return !!state.me?.email;
  },
  getCart: (state: CustomerState) => {
    return state.me?.shoppingCart || null;
  },
};